import React from 'react'
import { ReactComponent as ArrowLeftIcon } from '../../../assets/arrow_left.svg'
import * as S from './styles'
import { ArrowRightIcon } from './styles'

export type Props = {
  current: number
  onClickLeft?: () => void
  onClickRight?: () => void
  onClickFirstPage?: () => void
  onClickLastPage?: () => void
  totalPage: number
}

export default function PaginationSingle({
  onClickFirstPage,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onClickLastPage,
  totalPage,
  current,
  onClickLeft,
  onClickRight,
}: Props) {
  return (
    <S.PaginationWrap>
      <S.PaginationContent>
        <S.PageButtonWrap disabled={current === 1}>
          <S.PageButton onClick={onClickFirstPage}>First</S.PageButton>
        </S.PageButtonWrap>
        <S.PageButtonWrap disabled={current === 1}>
          <S.PageButton onClick={onClickLeft}>
            <ArrowLeftIcon />
          </S.PageButton>
        </S.PageButtonWrap>
        <S.PageText>
          page {current} of {totalPage}
        </S.PageText>
        <S.PageButtonWrap disabled={totalPage <= current}>
          <S.PageButton onClick={onClickRight}>
            <ArrowRightIcon />
          </S.PageButton>
        </S.PageButtonWrap>
        <S.PageButtonWrap disabled={totalPage <= current}>
          {/* NOTE: 라스트 버튼 클릭시 오랫동안 펜딩걸리는 문제로 숨김처리 */}
          {/* <S.PageButton onClick={onClickLastPage}>Last</S.PageButton> */}
        </S.PageButtonWrap>
      </S.PaginationContent>
    </S.PaginationWrap>
  )
}
